import styled from 'styled-components/native'
import { atlTheme } from '../../atlTheme'

export const Container = styled.View`
  padding-top: ${atlTheme.SpacingAtomic}px;
  padding-bottom: ${atlTheme.SpacingAtomic}px;

  border-radius: ${atlTheme.BorderRadiusCard}px;
  background: ${atlTheme.ColorSurface};

  min-height: ${atlTheme.SpacingButtonMarginHorizontal}px;
  margin-top: ${atlTheme.SpacingBase}px;

  width: 100%;
`
